// extracted by mini-css-extract-plugin
export var quantityInput = "_nh-0";